export default "__VITE_ASSET__c80O7GK1__"